import { AxiosResponse } from 'axios';
import { ImportQuoteFileHistoryResponse } from '@/main/models/response';
import { ImportQuoteFileHistoryRequest } from '@/main/models/request';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';

export abstract class IQuoteImportApi {
  abstract getImportHistory(
    request: ImportQuoteFileHistoryRequest
  ): Promise<
    AxiosResponse<PaginationResponse<ImportQuoteFileHistoryResponse[]>>
  >;
  abstract downloadFileImportHistory(
    guidQuoteImport: string
  ): Promise<AxiosResponse<Result<string>>>;
  abstract downloadErrorFileImportHistory(
    guidQuoteImport: string
  ): Promise<AxiosResponse<Result<string>>>;
}

